<script lang="ts">
  import type { Alternative } from '@pin/schemas/client-state-response';
  import { trackEvent } from '../../util/snowplow';
  import { clientState } from '../../util/stores';

  export let submit: () => void;
  export let artist: Alternative;
</script>

<button
  class="vote-button"
  on:click={() => {
    trackEvent({ action: 'click:retry-submit-votes' }, $clientState.id);
    submit();
  }}
  title="Trykk for å prøve å sende inn din stemme igjen"
  aria-label="Stem på {artist.title}"
>
  <div class="vote-button-bg" />
  <div class="vote-button-inner">Prøv igjen</div>
</button>

<style>
  .vote-button {
    position: relative;
    padding: 0;
    background-color: transparent;
    z-index: 1;
    width: 100%;
  }
  .vote-button-inner {
    display: block;
    text-transform: uppercase;
    font-size: 1.5625rem;
    line-height: 2;
    font-weight: 890;
    letter-spacing: 0.2em;
    padding: 0.5635rem;
    background-color: var(--mgp-pink);
    margin: 0.5rem;
    box-shadow:
      0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 6.25417px 15.8588px rgba(0, 0, 0, 0.92),
      0px 3.50603px 8.8903px rgba(255, 0, 88, 0.275),
      0px 1.86203px 4.72157px rgba(255, 0, 88, 0.222141),
      0px 0.774832px 21px var(--mgp-pink);
  }

  .vote-button-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-color: rgba(255, 0, 77, 0.65);
  }
</style>
